import { render, staticRenderFns } from "./ChangeOfAddressQuestionnaire.vue?vue&type=template&id=fd28e2fe&"
import script from "./ChangeOfAddressQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./ChangeOfAddressQuestionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports